import { Icon } from '@iconify/react';
import { Button, Checkbox, Container, FormControl, FormControlLabel, FormHelperText, Grid, InputAdornment, InputLabel, Link, makeStyles, OutlinedInput, Paper, Tooltip, Typography } from "@material-ui/core";
import axios from "axios";
import { useEffect, useState } from "react";
import ReCAPTCHA from "react-google-recaptcha";
import { useForm } from "react-hook-form";
import NumberFormat from "react-number-format";
import { useHistory } from "react-router-dom";


const useStyles = makeStyles((theme) => ({
  paper: {
    padding: "30px",
  },
  title: {
    fontWeight: 600,
  },
  form: {
    width: "100%", // Fix IE 11 issue.
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(2),
  },
  submit: {
    textTransform: "none",
    borderRadius: 0,
    fontSize: "14px",
    backgroundColor: "#d8dbe4",
    "&:hover": {
      backgroundColor: "#f2f3f7",
    },
  },
}));

function PhoneFormat(value) {
  let phone
  if (value[0] === "7") {
    phone = value.substring(1);
  } else if (value[0] !== "7" && value[1] === "7") {
    phone = value.substring(0, 1) + value.substring(2);
  } else {
    phone = value
  }

  let firstPart, secondPart, thirdPart;
  if (phone && (phone[0] === "7" || phone[0] === "8")) {
    phone = phone.substring(1);
  }
  firstPart = phone.substring(0, 3).padEnd(3, "_")
  secondPart = phone.substring(3, 6).padEnd(3, "_")
  thirdPart = phone.substring(6, 10).padEnd(4, "_")

  return `+7 (${firstPart}) ${secondPart} - ${thirdPart}`
}

function MaskInput(props) {
  const { inputRef, onChange, ...other } = props;
  return (
    <NumberFormat
      {...other}
      getInputRef={inputRef}
      onValueChange={(values) => {
        onChange({
          target: {
            name: props.name,
            value: values.value,
          },
        });
      }}
      allowEmptyFormatting
      format={PhoneFormat}
    />
  );
}

const SearchOrderForm = () => {
  const history = useHistory();
  const classes = useStyles();
  const { register, handleSubmit, errors, trigger, setValue, clearErrors } =
    useForm({
      defaultValues: {
        isAnotherShop: false,
      },
    });
  const [countSubmit, setCountSubmit] = useState(0);
  const [_errors, setErrors] = useState([]);


  const onSubmit = (data) => {
    const { personalDataPolicyConfirm, personalDataPolicyAgreement, ...payload } = data;

    axios
      .post(`${process.env.REACT_APP_API_URL}/api/order/request`, payload, {
        withCredentials: true,
      })
      .then(({ data }) => {
        if (data?.success) {
          history.push("/order");
        } else {
          setErrors(data.errors);
        }
      });
  };

  useEffect(() => {
    register("number", {
      validate: (val) => !!val || "Обязательное поле",
    });
    register("phone", {
      validate: (val) => {
        if (!val) return "Обязательное поле";
        if (val.length < 10) return "Некорректный номер";
      },
    });
    register("isAnotherShop");
    register("personalDataPolicyConfirm", {
      validate: (val) => val || "Обязательное поле",
    });
    register("personalDataPolicyAgreement", {
      validate: (val) => val || "Обязательное поле",
    });
    register("recaptcha", {
      validate: (val) => {
        if (!val) return "Пройдите капчу";
      },
    });
  }, []);

  return (
    <Container maxWidth="xs">
      <Paper elevation={0} className={classes.paper}>
        <Typography variant="h6" className={classes.title}>
          Введите данные:
        </Typography>
        <form className={classes.form} noValidate>
          <FormControl
            variant="outlined"
            fullWidth
            style={{ marginBottom: "16px" }}
          >
            <InputLabel shrink>Номер заказа</InputLabel>
            <OutlinedInput
              onChange={(e) => {
                e.target.value = e.target.value.replaceAll(/(#|№| )/g, "");
                setValue("number", e.target.value);
                if (countSubmit) trigger("number");
              }}
              notched
              name="number"
              autoComplete="number"
              label="Номер заказа:"
              endAdornment={
                <InputAdornment position="end">
                  <Tooltip placement="top-start" title={<div style={{ fontSize: "12px" }}>Номер заказа может быть в разном формате: 000000-000000, 000000-FIM или SEB_00000.</div>}>
                    <Icon width="30" height="30" icon="eva:alert-circle-outline" />
                  </Tooltip>
                </InputAdornment>
              }
            />
            <FormHelperText error={true}>
              {errors.number?.message}
            </FormHelperText>
          </FormControl>
          <FormControl
            variant="outlined"
            fullWidth
            style={{ marginBottom: "16px" }}
          >
            <InputLabel shrink>Телефон указанный в заказе:</InputLabel>
            <OutlinedInput
              inputComponent={MaskInput}
              onChange={(e) => {
                setValue("phone", e.target.value);
                if (countSubmit) trigger("phone");
              }}
              notched
              name="phone"
              autoComplete="phone"
              label="Телефон указанный в заказе:"
            />
            <FormHelperText error={true}>
              {errors.phone?.message}
            </FormHelperText>
          </FormControl>
          <FormControlLabel
            control={
              <Checkbox
                onChange={(e) => {
                  setValue("isAnotherShop", e.target.checked);
                }}
                name="isAnotherShop"
                color="primary"
              />
            }
            label={
              <Typography variant='body2'>
                Заказ сделан на маркетплейсе: Ozon, Wildberries, Megamarket, Yandex.Market
              </Typography>
            }
            style={{ marginBottom: "16px", alignItems: "flex-start" }}
          />
          <Grid item style={{ marginBottom: "16px", alignItems: "flex-start" }}>
            <FormControlLabel
              control={
                <Checkbox
                  onChange={(e) => {
                    clearErrors('personalDataPolicyConfirm');
                    setValue("personalDataPolicyConfirm", e.target.checked);
                  }}
                  name="personalDataPolicyConfirm"
                  color="primary"
                />
              }
              label={
                <Typography variant='body2'>
                  Ознакомлен с <Link href="https://giper.fm/politic" style={{ cursor: 'pointer' }} color="textAccent" target='_bla'>Политикой обработки персональных данных</Link>
                </Typography>
              }
            />
            <FormHelperText error={true} style={{ marginLeft: 14, marginRight: 14 }}>
              {errors.personalDataPolicyConfirm?.message}
            </FormHelperText>
          </Grid>
          <Grid item style={{ marginBottom: "16px", alignItems: "flex-start" }}>
            <FormControlLabel
              control={
                <Checkbox
                  onChange={(e) => {
                    clearErrors('personalDataPolicyAgreement');
                    setValue("personalDataPolicyAgreement", e.target.checked);
                  }}
                  name="personalDataPolicyAgreement"
                  color="primary"
                />
              }
              label={
                <Typography variant='body2'>
                  Даю <Link href="/personal-data-policy" style={{ cursor: 'pointer' }} color="textAccent" target='_blank'>согласие на обработку своих персональных данных</Link>
                </Typography>
              }
            />
            <FormHelperText error={true} style={{ marginLeft: 14, marginRight: 14 }}>
              {errors.personalDataPolicyConfirm?.message}
            </FormHelperText>
          </Grid>


          <Grid container justify="center" style={{ marginBottom: "16px" }}>
            <ReCAPTCHA
              sitekey="6Lc-mqsZAAAAAO6g0sR5Vxl-NOaw3Efc5tvxxsfh"
              onChange={(val) => {
                setValue("recaptcha", val);
                trigger("recaptcha");
              }}
              hl="ru"
            />
            <FormHelperText error={true}>
              {errors.recaptcha?.message}
            </FormHelperText>
          </Grid>

          <Grid container justify="center">
            <Grid item>
              <Button
                onClick={handleSubmit(onSubmit, () => setCountSubmit(1))}
                className={classes.submit}
                variant="contained"
                disableElevation
              >
                Запросить
              </Button>
            </Grid>
          </Grid>

          <Grid container justify="center">
            {_errors &&
              _errors.map((message, i) => {
                return (
                  <FormHelperText key={i} error={true}>
                    {message}
                  </FormHelperText>
                );
              })}
          </Grid>
        </form>
        <Grid container justify="center">
          <Typography variant="body2" color="textSecondary">
            При возникновении проблем позвонить по номеру <Link href="tel:88006002819" style={{ cursor: 'pointer' }}>8 (800) 600-28-19</Link> (10:00-19:00) или напишите на <Link href="mailto:help@giper.fm">help@giper.fm</Link>.
          </Typography>
        </Grid>
      </Paper>
    </Container >
  );
};
export default SearchOrderForm;
